let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../POS.js";
import i18n from "../utils/i18n";


let main = function () {
    var PrinterStatusView = Backbone.View.extend({
        el: "#printerStatusModal",
        events: {
            "click .clearQueueBtn": "onClearQueueBtnClick"
        },
        initialize: function () {
            this.model.on("change", this.render.bind(this));
            this.$el.on('hidden.bs.modal', _.bind(function () {
                this.model.set({"errors": {}});
                console.log("reset error model");
            }, this));
            this.render();
        },
        render: function () {
            var self = this;
            self.$(".printers").empty();
            self.$(".printers-container").addClass("hidden");
            self.$(".printer-offline").addClass("hidden");
            self.$(".unconfig").addClass("hidden");
            if (self.model) {
                if (self.model.get('printers').length > 0) {
                    self.$(".printers-container").removeClass("hidden");
                    $.each(self.model.get('printers'), function (index, printer) {
                        self.$(".printers").append(self._buildPrinter(printer));
                    });
                } else {
                    self.$(".unconfig").removeClass("hidden");
                }
            } else {
                self.$(".printer-offline").removeClass("hidden");
            }
            if (POS.getUseCloudPrint()) {
                if (!$.isEmptyObject(self.model.get('errors'))) {
                    this.$el.modal("show");
                }
            }
        },
        show: function () {
            this.render();
            this.$el.modal("show");
        },
        hide: function () {
            this.$el.modal("hide");
        },
        onClearQueueBtnClick: function () {
            $.post("/pos/clearPrintQueue")
                .then(() => {
                    alert(i18n.msg("pos.printer.queue.clearsuccess"));
                    this.hide();
                });
        },
        _buildPrinter: function (model) {
            var self = this, printer = model, template;

            var errorCount = self.model.get('errors') ? self.model.get('errors')[printer.name] : 0;
            if (typeof(errorCount) == 'undefined') {
                errorCount = 0;
            }

            var errorBadge = '';
            if (errorCount > 0) {
                errorBadge = '&nbsp;<span class="badge">' + errorCount + '</span>';
            }

            var printerType = i18n.msg('pos.printer.type.' + printer.type);
            template = $("<li class='printer list-group-item'>" +
                "<span class='name'>" + printer.name + "</span>" +
                "<div class='printer-status " + (printer.online ? 'online' : 'offline') + "'><span class='printer-type'>" + printerType + errorBadge + "</span></div>" +
                "</li>");
            return template;
        }
    });

    return PrinterStatusView;
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/PrinterStatusView.js